module.exports = __webpack_public_path__ + "media/images/weather/stormy-a1c1820afdeba9b1308cc53561c05f91.jpg";